<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.modulo" [titulo]="DAT_TITULOS.modulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="text-end">
          <button (click)="sendAll()" class="btn btn-outline-info mr-2">
            Envio masivo
          </button>
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nueva}} {{ DAT_TITULOS.titulo }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div class="mb-3">
      <app-promo-accordion [promos]="promosId" [selectedPromos]="selectedPromos"></app-promo-accordion>
    </div>
    <div class="row mb-4">
      <div class="form-check form-switch col-6 col-md-4 d-flex flex-column">
        <label for="actives">Mostrar solo activas</label>
        <input
          class="form-check-input ms-0"
          type="checkbox"
          id="actives"
          [(ngModel)]="onlyActives"
          (change)="obtenerTodo()"
        >
      </div>
      <div class="form-group col-6 col-md-4">
          <app-lfsa-page-size-selector [pageSize]="DAT_AG_GRID.paginacion" [pageSizeOptions]="[15, 25, 50]" (onPageSizeChange)="onPageSizeChanged($event)"></app-lfsa-page-size-selector>
      </div>
    </div>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData" [rowSelection]="'multiple'">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
  [titulo]="isCreate ? 'Crear Promoción' : 'Editar Promoción'" (onClose)="closeModal()" idOpen="promocionModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <app-promocion-form
    [cmbTipoPromocion]="cmbTipoPromocion"
    [loading]="loading"
    (create)="guardar($event)"
    (back)="closeModal()"
    *ngIf="verFormulario"></app-promocion-form>
</ng-template>
<!-- END MODAL -->


<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'duplicarModal'" [idClose]="'cerrarDuplicarModal'" [innTemplate]="duplicarModal"
  [titulo]="'Duplicar promoción ' + copyIdPromo" (onClose)="closeDuplicarModal()" idOpen="copyPromoModal"></app-lfsa-modal>
<ng-template #duplicarModal>
  <app-duplicar-promocion [idPromo]="copyIdPromo" (onSuccess)="obtenerTodo()" *ngIf="copyIdPromo"></app-duplicar-promocion>
</ng-template>
